import { render, staticRenderFns } from "./SOMenuDetailPopup.vue?vue&type=template&id=c663af08&scoped=true"
import script from "./SOMenuDetailPopup.vue?vue&type=script&lang=ts"
export * from "./SOMenuDetailPopup.vue?vue&type=script&lang=ts"
import style0 from "./SOMenuDetailPopup.vue?vue&type=style&index=0&id=c663af08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c663af08",
  null
  
)

export default component.exports